import { useInstantSearch } from 'react-instantsearch-core';

export interface SearchNoResultsBoundaryProps {
    children: JSX.Element | JSX.Element[];
    fallback: JSX.Element | JSX.Element[];
}

export function SearchNoResultsBoundary(props: SearchNoResultsBoundaryProps) {
    const { children, fallback } = props;
    const { results } = useInstantSearch();

    // The `__isArtificial` flag makes sure not to display the No Results message
    // when no hits have been returned.
    if (!results.__isArtificial && results.nbHits === 0) {
        return (
            <>
                {fallback}
                <div hidden>{children}</div>
            </>
        );
    }

    return children;
}

export default SearchNoResultsBoundary;
